/* raw layout hash: _guest-loaners-overdue-tracker-layout:0e4122dbde53ff0414bc33a99c4a42b02781b723de0a5c5671064400f76a108a */
import React from "react";
import AppShell from "./AppShell.jsx";

// Layout "_guest-loaners-overdue-tracker-layout" (RawHTMLDesign/layouts/_guest-loaners-overdue-tracker-layout.html)
export default function GuestLoanersOverdueTrackerLayout({ children }) {
  return <AppShell menuKey="set6">{children}</AppShell>;
}
